import styled from 'styled-components'

import rem from '../../../../../styles/tools/rem'

import { txt16OpenSansBold, txt16OpenSans } from '../../../../../styles/settings/types'

import { darkSlateBlue, paleGray, red, deliveredGreen } from '../../../../../styles/settings/colors'

export const SearchIconContainer = styled.div`
  position: absolute;
  left: 15px;
  top: 20px;
`

export const SearchInput = styled.input`
  border: none;
  border-bottom: 3px solid ${darkSlateBlue};
  ${({ plateIsValid }) => plateIsValid && `border-bottom: 3px solid ${deliveredGreen}`};
  ${({ invalidInput }) => invalidInput && `border-bottom: 3px solid ${red}`};
  background-color: ${paleGray};
  padding: ${rem('16px')} ${rem('16px')} ${rem('16px')} ${rem('50px')};
  line-height: ${rem('24px')};
  color: ${darkSlateBlue};
  ${txt16OpenSans};
  width: 100%;
  margin-bottom: ${rem('15px')};
`

export const Loading = styled.img`
  width: ${rem('25px')};
`

export const Error = styled.span`
  color: ${red};
  display: inline-block;
  font-family: OpenSans;
  font-size: ${rem('14px')};
  letter-spacing: ${rem('-0.3px')};
`

export const Valid = styled.span`
  color: ${deliveredGreen};
  display: inline-block;
  font-family: OpenSans;
  font-size: ${rem('14px')};
`

export const SearchInputWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  ${({ hide }) => hide && `display: none`};
`

export const Container = styled.section`
  width: 100%;
  padding: ${rem('50px')} 0 ${rem('15px')};
  background-color: white;
  display: flex;
  justify-content: center;
  flex-direction: column;
`

export const InputContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  width: ${rem('940px')};
  align-items: flex-start;
`

export const SearchButton = styled.button`
  background-color: ${darkSlateBlue};
  color: white;
  ${txt16OpenSansBold};
  padding: ${rem('13px')} ${rem('35px')};
  border-radius: 25px;
  margin-left: ${rem('20px')};
  ${({ plateIsValid }) => plateIsValid && `display:none;`};
`

export const FilterTypeContainer = styled.div`
  padding: 0;
  overflow: auto;
`

export const FilterTypes = styled.ul`
  display: flex;
  justify-content: flex-start;
  list-style: none;
  margin: 0;
  min-height: ${rem('56px')};
  padding: 0;
  width: 100%;
  align-items: center;
`

export const ListItem = styled.li`
  margin-right: 40px;
`

export const InputRadio = styled.input.attrs({
  type: 'radio'
})`
  display: none;
`
export const Radio = styled.span`
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  margin: 0 5px 0 0;
  width: 20px;
  height: 20px;
  border-radius: 11px;
  border: 2px solid #004c97;
  background-color: transparent;
`

export const CheckMark = styled.span`
  display: none;
  border-radius: 30px;
  width: 7px;
  height: 7px;
  position: absolute;
  top: 6px;
  left: 6px;
  content: ' ';
  background: white;
`

export const RadioLabel = styled.label`
  position: relative;
  color: ${darkSlateBlue};
  ${txt16OpenSansBold};
  padding-left: 30px;

  ${InputRadio}:checked ~ ${CheckMark} {
    display: block;
    z-index: 1;
  }
  ${InputRadio}:checked ~ ${Radio} {
    background-color: ${darkSlateBlue};
  }
`



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatementPartner/PartnerStatementsFilter/FilterByTag/styles.js